import { FraSlider } from "Components/fra-m-slider/fra-m-slider";
import { getParent, find } from "@kluntje/js-utils/lib/dom-helpers";
import { FraOverlay } from "Components/fra-m-overlay/fra-m-overlay";

/**
 * Custom Element to show lightbox gallery on slide image click
 */
class FRAGallerySlider extends FraSlider {
  /**
   * handle click on single slide,
   * if there is a link trigger click
   *
   * @param {HTMLLinkElement} link
   * @param {Event} e
   */
  handleSlideClick(link: any, e: any): void {
    const overlay = find(getParent(this as HTMLElement, ".fra-m-gallery") as HTMLElement, ".fra-m-gallery__overlay");
    const clickedLink = find(
      getParent(e.target as HTMLElement, ".fra-js-slider__slide") as HTMLElement,
      ".fra-e-button",
    );
    let slideIndex;

    if (clickedLink !== null) {
      slideIndex = clickedLink.getAttribute("data-fra-index") as string;
      this.openOverlay(overlay as FraOverlay, slideIndex);
    }
  }

  /**
   * calls overlay's open function and shows active Slide
   *
   * @param {FraOverlay} overlay
   * @param {string} slideIndex
   */
  openOverlay(overlay: FraOverlay, slideIndex: string): void {
    const overlaySlider = find(overlay, ".fra-m-slider") as FraSlider;

    overlay.open();
    overlaySlider.setState({ activeSlide: parseInt(slideIndex, 10) });
  }
}

customElements.define("fra-m-gallery-slider", FRAGallerySlider);

export default FRAGallerySlider;
